import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Translate } from '../../shared/LanguageService';
import { Button, FormGroup, Checkbox } from 'react-bootstrap';
import PhotographerModal from './PhotographerModal';
import * as userActions from '../../actions/userActions';
import PhotographersList from './PhotographersList';
import * as photographerActions from './PhotographerActions';
import notify from '../../shared/feedback/notifications';
import LogsModal from '../logs/LogsModal';

class PhotographersPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showModal: false,
            showLogsModal: false,
            userId: -1,
            showDiscontinued: false
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.openEditUserModal = this.openEditUserModal.bind(this);
        this.openCreateUserModal = this.openCreateUserModal.bind(this);
        this.toggleLogsModal = this.toggleLogsModal.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    componentDidMount() {
        this.props.actions
            .getPhotographers()
            .then(() => {
                if (this.props.params && this.props.params.id) {
                    this.openEditUserModal(this.props.params.id);
                }
            })
            .catch((errorResponse: any) => {
                errorResponse.errors.forEach((e: any) => {
                    notify.failure(e.value);
                });
            });
    }

    openEditUserModal(id: number) {
        this.setState({ userId: id });
        this.toggleModal();
    }

    openCreateUserModal() {
        this.setState({ userId: -1 });
        this.toggleModal();
    }

    toggleLogsModal(id?: number) {
        this.setState({ showLogsModal: !this.state.showLogsModal, userId: id });
    }

    toggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    onCheckboxChange(e: any) {
        this.setState({ showDiscontinued: !this.state.showDiscontinued });
    }

    render() {
        let photographers = this.props.photographers;
        return (
            <div>
                <h1>{Translate('photographers/page/title/photographers')}</h1>
                <div className="row">
                    <div className="col-md-3 no-label">
                        <FormGroup>
                            <Checkbox
                                className=""
                                name="showDiscontinued"
                                checked={this.state.showDiscontinued}
                                onChange={this.onCheckboxChange}
                            >
                                <span>
                                    {Translate(
                                        'photographers/page/input-label/include-discontinued'
                                    )}
                                </span>
                            </Checkbox>
                        </FormGroup>
                    </div>
                    <Button
                        onClick={this.openCreateUserModal}
                        className="pull-right"
                        bsStyle="success"
                        bsSize="large"
                    >
                        {Translate('photographers/page/button-label/add-photographer')}
                    </Button>
                </div>
                {this.state.showModal && (
                    <PhotographerModal
                        showModal={this.state.showModal}
                        toggleModal={this.toggleModal}
                        userId={this.state.userId}
                    />
                )}

                {this.state.showLogsModal && (
                    <LogsModal
                        id={this.state.userId}
                        type="UserId"
                        shouldShowModal={this.state.showLogsModal}
                        closeModal={this.toggleLogsModal}
                    />
                )}

                <PhotographersList
                    photographers={photographers}
                    showDiscontinued={this.state.showDiscontinued}
                    edit={this.openEditUserModal}
                    logs={this.toggleLogsModal}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        photographers: state.photographers.list.sort((a: any, b: any) => {
            return a.id - b.id;
        })
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getPhotographers: () => dispatch(photographerActions.listPhotographers())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PhotographersPage));
